import React, { useCallback, useState } from 'react';

import ContactFormView from '../../ContactFormView';
import { PrimaryButton } from '../../generic/Button';
import Section from '../../generic/Section';
import styles from './index.module.scss';
import { useTrackCustomEvent } from '../../../utils/useTrackCustomEvent';

export default function GetInTouch() {
  let trackCustomEvent = useTrackCustomEvent();

  const [isContactFormVisible, setIsContactFormVisible] = useState(false);

  function clickHandler() {
    setIsContactFormVisible(true);
  }

  const trackContactClickHandler = useCallback(() => {
    trackCustomEvent({
      category: 'Workspace Get In Touch',
      action: `'Contact use here' (with empty quote) clicked`,
      label: window.location.pathname,
    });
    clickHandler();
  }, [trackCustomEvent]);

  return (
    <Section className={styles.getInTouch}>
      <h3 className={styles.header}>
        Interested in this setup? <br />
        Get in touch.
      </h3>
      <PrimaryButton clickHandler={trackContactClickHandler}>Contact us</PrimaryButton>
      <ContactFormView isVisible={isContactFormVisible} closeFn={() => setIsContactFormVisible(false)} standalone />
    </Section>
  );
}

// function gotQuoteContent(quote) {
//   return Boolean(quote.length);
// }
